import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LanguageService } from '@core/i18n/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App implements OnInit {
  private readonly language = inject(LanguageService);

  ngOnInit(): void {
    this.language.init();
  }
}
